import { memo } from 'react'

const UDDCheckboxControls = ({
    enabledFiles,
    validUploadData,
    setValidUploadData,
}) => {
    
    return (
        
        <tr>
            <th>
                <input
                    type="checkbox"
                    className="checkbox checkbox-primary checkbox-sm"
                    checked={validUploadData.length > 0 && validUploadData.length === enabledFiles.length}
                    onChange={() => {
                        if (validUploadData.length > 0
                            && validUploadData.length === enabledFiles.length)
                            setValidUploadData([])
                        else
                            setValidUploadData(enabledFiles)
                    }} />
            </th>
            <th>Name</th>
            <th>Size</th>
        
        </tr>
        
    )
    
    /* return (
        
        <div className='flex gap-2 pb-2 items-center w-[250px]'>
            
            <input
                type="checkbox"
                className="checkbox checkbox-primary checkbox-sm"
                checked={validUploadData.length > 0 && validUploadData.length === enabledFiles.length}
                onChange={() => {
                    if (validUploadData.length > 0
                        && validUploadData.length === enabledFiles.length)
                        setValidUploadData([])
                    else
                        setValidUploadData(enabledFiles)
                }} />
            
            <span className="inline-block max-w-[200px] whitespace-nowrap
                overflow-hidden text-ellipsis">
                
                {validUploadData.length > 0
                    && validUploadData.length === enabledFiles.length
                    && 'Unselect All'}
                
                {!(validUploadData.length > 0
                    && validUploadData.length === enabledFiles.length)
                    && 'Select All'}
            
            </span>
        
        </div>
        
    ) */
    
}

export default memo(UDDCheckboxControls)
